import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import datastore from '@datastore';
import FormControlSelect from './form_control_select';

const FormControlStateSelect = props => {
  const countryStates = _.get(props.countryStates, props.country);
  const isEmptyCountryStates = _.isEmpty(countryStates);

  return (
    <FormControlSelect
      {...props}
      placeholder={isEmptyCountryStates ? 'N/A' : props.placeholder}
      disabled={isEmptyCountryStates}
      options={_.map(countryStates, state => ({
        value: state.code,
        label: state.name,
      }))}
      searchable={props.searchable}
    />
  )
};

FormControlStateSelect.propTypes = {
  country: PropTypes.string.isRequired,
  countryStates: PropTypes.shape({
    label: PropTypes.string,
    name: PropTypes.string,
  }),
  placeholder: PropTypes.string,
  searchable: PropTypes.bool,
};

FormControlStateSelect.defaultProps = {
  searchable: true,
};

const mapStateToProps = state => ({
  countryStates: datastore.selectors.getStatesByCountry(state),
});

export default connect(mapStateToProps)(FormControlStateSelect);
